<template>
  <div class="min-h-screen bg-gray-100">
    <TopBar :role="this.role" :user-data="this.userData.data" v-if="userData && role"/>
    <main class="max-w-[1300px] m-auto py-4 px-2 sm:px-4">
      <OlimpiadasLiveSessionBanner variant="app" />
      <StudentStats />
      <CourseNavigation class="mt-6" />
    </main>
  </div>
</template>

<script>
import TopBar from "./components/TopBar.vue";
import StudentStats from "./components/StudentStats.vue";
import CourseNavigation from "./components/CourseNavigation.vue";
import OlimpiadasLiveSessionBanner from "@/views/V2/olimpiadas/OlimpiadasLiveSessionBanner.vue";

export default {
  name: "DashboardV2",
  components: {
    TopBar,
    StudentStats,
    CourseNavigation,
    OlimpiadasLiveSessionBanner,
  },
  data() {
    return {
      role: null,
      userData: null
    }
  },
  mounted() {
    this.role = window.localStorage.getItem("role");
    this.userData = JSON.parse(window.localStorage.getItem("auth"));

    if (window.opener) {
      window.opener.postMessage({
        type: 'googleAuth',
      }, window.location.origin);
    }
  },
};
</script>
